import { type FunctionComponent } from "react";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { HeaderTab } from "scmp-app/components/tracking/google-analytics-4/types";
import { pathname as plusPathName } from "scmp-app/pages/plus";

import { Container, SCMPPlusLinkList } from "./styles";

type Props = {
  className?: string;
};

export const SCMPPlusLink: FunctionComponent<Props> = ({ className }) => {
  const getTabClickHandler = (headerTab: HeaderTab) => () => {
    sendGA4Tracking({
      action: "click",
      category: "header",
      customized_parameters: {
        header: headerTab,
      },
      subcategory: "",
    });
  };

  return (
    <Container className={className}>
      <SCMPPlusLinkList onClick={getTabClickHandler("scmp_plus")} pathname={plusPathName}>
        SCMP PLUS
      </SCMPPlusLinkList>
    </Container>
  );
};

SCMPPlusLink.displayName = "SCMPPlusLink";
